import React from 'react';
import {Routes, Route} from 'react-router-dom';
import HomePage from './components/HomePage';
import DownloadPage from './components/DownloadPage';
import CasePage from './components/CasePage';
import './App.css';
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import ProductPage from "./components/ProductPage";

function App() {
    return (
        <div className="App">
            <NavigationBar/>
            <div className="page-content">
              <Routes>
                  <Route path="/" element={<HomePage/>}/>
                  <Route path="/download" element={<DownloadPage/>}/>
                  <Route path="/case" element={<CasePage/>}/>
                  <Route path="/product" element={<ProductPage/>}/>
              </Routes>
              <Footer/>
            </div>
        </div>
    );
}

export default App;